import { FC } from 'react'

export const NoContent: FC = () => (
    <div className='w-full h-full grid items-center justify-center'>
        <p className='text-[#00000025] text-3xl'>Empty</p>
    </div>
)
